
	<template>
		<div class="content">


				<table>
					<tr> 
						<td style="width: 100%;"></td>
				        	<td style="width: 150px;">
				      			<base-button class="btn btn-primary" @click="updateMappedClass()">Save</base-button>
				        	</td>
				        	<td style="width: 150px;">
				        	<td style="width: 150px;">
				        		
								<div >
								  <div class="container">
												    <base-button class="btn btn-primary" @click="modal2MappedClasses = true">Add</base-button>
								              <modal :show.sync="modal2MappedClasses">
								                <template slot="header">
								                  <h5 class="modal-title" id="exampleModalLabel">Add MappedClass</h5>
								                </template>
								                <div>
								                  <form @submit.prevent>
												                  </form>
								                </div>
								                <template slot="footer">
								                  <base-button type="primary" @click="handleAddSubmitted()">Save</base-button>
								                </template>
								              </modal>
												  </div>
								</div>
				        	</td>
					</tr> 
				</table>



				<table>
      <template>
        <div class="content">
          <a-modal :footer="null" :visible="showProgressBar" class="centered-modal" v-if="showProgressBar"
                   :closable="false">
            <div style="text-align: center; padding: 20px;">
              <h5>Please wait...</h5>
            </div>
          </a-modal>
        </div>
        <div class="content">
          <a-modal :footer="null" :visible="userPermissionDialog" :closable="false" class="centered-modal" v-if="userPermissionDialog">
            <div style="text-align: center; padding: 20px;">
              <h5>User does not have permission</h5>
              <button @click="handlePermissionDialogClose">OK</button>
            </div>
          </a-modal>
        </div>
      </template>

	
	
	
		
		
										<tr> 
					<td class="detail_view_column_2">Mapped Class Id</td>
																							    		<td class="detail_view_column_1"><b> {{ mappedClassDetails.mappedClassId }} </b></td>
					    						    														</tr>
																																																

	
						<tr>
				<td>
					<div>Domain Class Name</div>		
				</td>
				<td  class="detail_view_column_1">
					<div>
					  <div>
						  <vue-autosuggest class="detail_view_input" label="DomainClassName" type="text" placeholder="Enter DomainClassName" v-model="mappedClassDetails.domainClassName" :suggestions="filteredSuggestionsDomainClassName" :input-props="{id:'autosuggest__inputDomainClassName'}" @selected="selectHandlerDomainClassName" @input="onInputChangeDomainClassName" :getSuggestionValue="s => s.item.domainClassName.toString()">
						    <template slot-scope="{ suggestion }">
						      <div>
						        <b>{{suggestion.item.domainClassName}}</b>
						      </div>
						    </template>
						  </vue-autosuggest>
					  </div>
					</div>  
				</td>
			</tr>
								<tr>
				<td>
					<div>Mapped Domain Class Name</div>		
				</td>
				<td  class="detail_view_column_1">
					<div>
					  <div>
						  <vue-autosuggest class="detail_view_input" label="MappedDomainClassName" type="text" placeholder="Enter MappedDomainClassName" v-model="mappedClassDetails.mappedDomainClassName" :suggestions="filteredSuggestionsMappedDomainClassName" :input-props="{id:'autosuggest__inputMappedDomainClassName'}" @selected="selectHandlerMappedDomainClassName" @input="onInputChangeMappedDomainClassName" :getSuggestionValue="s => s.item.mappedDomainClassName.toString()">
						    <template slot-scope="{ suggestion }">
						      <div>
						        <b>{{suggestion.item.mappedDomainClassName}}</b>
						      </div>
						    </template>
						  </vue-autosuggest>
					  </div>
					</div>  
				</td>
			</tr>
								<tr>
				<td>
					<div>Application Name</div>		
				</td>
				<td  class="detail_view_column_1">
					<div>
					  <div>
						  <vue-autosuggest class="detail_view_input" label="ApplicationName" type="text" placeholder="Enter ApplicationName" v-model="mappedClassDetails.applicationName" :suggestions="filteredSuggestionsApplicationName" :input-props="{id:'autosuggest__inputApplicationName'}" @selected="selectHandlerApplicationName" @input="onInputChangeApplicationName" :getSuggestionValue="s => s.item.applicationName.toString()">
						    <template slot-scope="{ suggestion }">
						      <div>
						        <b>{{suggestion.item.applicationName}}</b>
						      </div>
						    </template>
						  </vue-autosuggest>
					  </div>
					</div>  
				</td>
			</tr>
				
		</table>
	
	




















			<a-tabs v-model:activeKey="activeKey">
											</a-tabs>

		</div>
	</template>

<script>

import MappedClassService from "../services/MappedClassService";
import Modal from "@/components/Modal";
import BaseButton from "@/components/BaseButton";
import BaseInput from "@/components/BaseInput";
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";
import { Card } from "@/components/Card";
import { ASelect, ASelectOption, AButton, Table, Pagination, message } from "ant-design-vue";
import { VueAutosuggest } from "vue-autosuggest";
import { UploadOutlined } from '@ant-design/icons-vue';
import Datepicker from 'vuejs-datepicker';
import ApplicationTable from "@/components/ApplicationTable";
import ApplicationService from "../services/ApplicationService";
import DomainClassTable from "@/components/DomainClassTable";
import DomainClassService from "../services/DomainClassService";


const tableColumns = [];
const tableData = [];
const fileList = ([]);
let file = ({});
const checked = (false);
let yearValue = ('');

export default {
  props: {
    mappedClassId: {
      type: String,
      required: true
    }
  },
  components: {
		Modal,
		BaseButton,
		BaseInput,
		VueAutosuggest,
		UploadOutlined,
		Datepicker,
  },
  data() {
    return {
      mappedClassToAdd: {},
      modal2MappedClasses: false,
      mappedClassDetails: null,


      fileList,
      checked,
	  yearValue,



      domainClassNameQuery: "",
      suggestionsDomainClassName: [],
      suggestionsLoadedDomainClassName: false,

      mappedDomainClassNameQuery: "",
      suggestionsMappedDomainClassName: [],
      suggestionsLoadedMappedDomainClassName: false,

      applicationNameQuery: "",
      suggestionsApplicationName: [],
      suggestionsLoadedApplicationName: false,
    };
  },
  methods: {

    
    selectHandlerDomainClassName(item) {
      this.mappedClassDetails.domainClassName = item.item.domainClassName.toString();
      this.mappedClassDetails.domainClassId = item.item.domainClassId.toString();
      
    },

    async getDomainClassNameSuggestions()
    {
      try {
  		const searchDTO = {
			sortBy: "domainClassName", 
			sortOrder: "asc", 
			searchQuery: this.mappedClassDetails.domainClassName, 
			page: "0", 
			size: "15"
		};
        let response = await DomainClassService.getAllDomainClasses(searchDTO);
        this.suggestionsDomainClassName = response.data.domainClasses;
        this.suggestionsLoadedDomainClassName = true;
      } catch (error) {
        console.error('Error fetching domain_classes list for auto-complete: ', error);
      }
    },
    
	onInputChangeDomainClassName(text) {
      this.getDomainClassNameSuggestions();
    },
    selectHandlerMappedDomainClassName(item) {
      this.mappedClassDetails.mappedDomainClassName = item.item.mappedDomainClassName.toString();
      this.mappedClassDetails.mappedDomainClassId = item.item.mappedDomainClassId.toString();
      
    },

    async getMappedDomainClassNameSuggestions()
    {
      try {
  		const searchDTO = {
			sortBy: "mappedDomainClassName", 
			sortOrder: "asc", 
			searchQuery: this.mappedClassDetails.mappedDomainClassName, 
			page: "0", 
			size: "15"
		};
        let response = await DomainClassService.getAllDomainClasses(searchDTO);
        this.suggestionsMappedDomainClassName = response.data.domainClasses;
        this.suggestionsLoadedMappedDomainClassName = true;
      } catch (error) {
        console.error('Error fetching domain_classes list for auto-complete: ', error);
      }
    },
    
	onInputChangeMappedDomainClassName(text) {
      this.getMappedDomainClassNameSuggestions();
    },
    selectHandlerApplicationName(item) {
      this.mappedClassDetails.applicationName = item.item.applicationName.toString();
      this.mappedClassDetails.imageFile = item.item.imageFile.toString();
      
    },

    async getApplicationNameSuggestions()
    {
      try {
  		const searchDTO = {
			sortBy: "applicationName", 
			sortOrder: "asc", 
			searchQuery: this.mappedClassDetails.applicationName, 
			page: "0", 
			size: "15"
		};
        let response = await ApplicationService.getAllApplications(searchDTO);
        this.suggestionsApplicationName = response.data.applications;
        this.suggestionsLoadedApplicationName = true;
      } catch (error) {
        console.error('Error fetching applications list for auto-complete: ', error);
      }
    },
    
	onInputChangeApplicationName(text) {
      this.getApplicationNameSuggestions();
    },

	
	handleSwitchChange(lifAnswerId, checked) {
	    this.answers.forEach(function(answer) {
	    	if (answer.questionType == '2') {
		    	if (answer.lifAnswerId == lifAnswerId) {
					answer.answerb = checked;
					if ( checked) {
						answer.answer = "Yes";
					} else {
						answer.answer = "No";
					}
				}
	    	}
		});
	},

 	handlePermissionDialogClose() {
      this.userPermissionDialog = false;
    },

    async handleAddSubmitted() {
      this.modal2MappedClasses = false;

      const jsonData = JSON.stringify(this.mappedClassToAdd);
      console.log(jsonData);
      
      const res = await MappedClassService.addMappedClass(jsonData);

      if (res.status === 200) {
        this.$notify({
          component: NotificationTemplate,
          icon: "tim-icons icon-bell-55",
          type: "success",
          timeout: 3000,
        });
      }
	},

    async updateMappedClass() {

      const jsonData = JSON.stringify(this.mappedClassDetails);
      const res = await MappedClassService.update(jsonData);

      if (res.status === 200) {
//        this.$notify({
//          component: NotificationTemplate,
//          icon: "tim-icons icon-bell-55",
//          type: "success",
//          timeout: 3000,
//        });

//        this.modalMappedClasses = false;
//        this.getAllMappedClasses();
      }
    },


    async getMappedClassDetails() {
      try {
			let response = await MappedClassService.get(this.mappedClassId);
			this.mappedClassDetails = response.data;

			let hasAnswers = 0;



			if (hasAnswers) {			
		        this.answers.forEach(function(answer) {
		            if (answer.answer === "Yes") {
		               temp = true;
		            } else {
		               temp = false;
		            }
		        });
			}


	    
      } catch (error) {
        console.error('Error fetching mappedClass details:', error);
      }
    },


	formatTime(dateString) {
      if(dateString !== null){
        const date = new Date(dateString);
      return `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')} EST`;
      }
      // Format the date here as needed, for example:
    },  
    
 formatDate(dateString) {
    if (dateString !== null) {
	    const date = new Date(dateString);
	    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	    const day = String(date.getDate()).padStart(2, '0');
	    const monthAbbreviation = months[date.getMonth()];
	    const year = date.getFullYear();
	    return `${day} ${monthAbbreviation} ${year}`;
  	}
  	// Handle the case when dateString is null or invalid
  	return '';
    
   },

  },
  mounted() {
    this.getMappedClassDetails();
  },
  computed: {
	  filteredSuggestionsDomainClassName() {
	    if (!this.suggestionsLoadedDomainClassName)
	      return [];
	    this.domainClassNameQuery = this.mappedClassDetails.domainClassName.toString();
	    return [
	      {
	        data: this.suggestionsDomainClassName
	      }
	    ];
	  },
	  filteredSuggestionsMappedDomainClassName() {
	    if (!this.suggestionsLoadedMappedDomainClassName)
	      return [];
	    this.mappedDomainClassNameQuery = this.mappedClassDetails.mappedDomainClassName.toString();
	    return [
	      {
	        data: this.suggestionsMappedDomainClassName
	      }
	    ];
	  },
	  filteredSuggestionsApplicationName() {
	    if (!this.suggestionsLoadedApplicationName)
	      return [];
	    this.applicationNameQuery = this.mappedClassDetails.applicationName.toString();
	    return [
	      {
	        data: this.suggestionsApplicationName
	      }
	    ];
	  },
  },
  
};
</script>
<style>

.detail_view_input input {
	text-align: center;
}

.detail_view_column_1 {
	width: 250px; 
	text-align: center;
}
.detail_view_column_2 {
	min-width: 250px; 
}
.input {
	text-align: center;
}
#autosuggest__input {
  display: inline-block;
}
.autosuggest__results-container {
	position: relative;
}
.autosuggest__results {
	font-weight: 300;
	margin: 0;
	position: absolute;
	z-index: 10000001;
	border: 1px solid #e0e0e0;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	background: white;
}
.autosuggest__results ul {
	list-style: none;
	padding-left: 0;
	margin: 0;
}
.autosuggest__results .autosuggest__results-item {
	cursor: pointer;
	padding: 5px;
}
#autosuggest ul:nth-child(1) > .autosuggest__results_title {
	border-top: none;
}
.autosuggest__results .autosuggest__results_title {
	color: gray;
	font-size: 11px;
	margin-left: 0;
	padding: 15px 13px 5px;
	border-top: 1px solid lightgray;
}
.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results
.autosuggest__results-item.autosuggest__results-item--highlighted {
	background-color: #F6F6F6;
}

.mappedClass-image {
				    	height: 250px;
			}

.inline-item {
  display: inline-block;
  margin-right: 100px; /* Adjust margin as needed */
}

.switch-container {
	width: 215px; 
    text-align: right;
    margin-right: 15px;
    margin-top: 5px;
    margin-bottom: 5px;
}



</style>
